import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/chalkApi";
import { ChalkActionButton, ChalkCard } from "./primitives";

export function RedeemCodeCard() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try {
      const r = await api.redeemKit(code.trim());
      toast.success(r.outcome === "already_paid" ? "You're already on Chalkboard." : "Your 30-day Chalkboard trial is on.");
      setCode("");
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  }
  return (
    <ChalkCard data-testid="redeem-code-card" style={{ marginTop: 8 }}>
      <div style={{ fontSize: 14, fontWeight: 500, color: "var(--chalk-board)" }}>Redeem code</div>
      <input data-testid="redeem-code-input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Paste your kit code"
        style={{ width: "100%", fontSize: 16, padding: 10, borderRadius: 10, border: "0.5px solid var(--chalk-border)", margin: "8px 0", boxSizing: "border-box" }} />
      <ChalkActionButton testId="redeem-code-btn" label="Redeem" loading={busy} disabled={code.trim().length < 3} onClick={go} />
    </ChalkCard>
  );
}

export function EmailTipsCard() {
  const [on, setOn] = useState(null);
  useEffect(() => { api.getEmailPrefs().then((d) => setOn(d.marketing)).catch(() => {}); }, []);
  async function toggle() {
    const d = await api.setEmailPrefs(!on);
    setOn(d.marketing);
  }
  if (on === null) return null;
  return (
    <ChalkCard style={{ marginTop: 8 }}>
      <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 14 }}>
        Tips and trial emails
        <input type="checkbox" data-testid="email-tips-toggle" checked={on} onChange={toggle} />
      </label>
      <div style={{ fontSize: 11, color: "var(--chalk-muted)", marginTop: 4 }}>Account and billing notices always arrive.</div>
    </ChalkCard>
  );
}
